import {z} from 'zod/v4';
import {objectIdStringZ4} from '@packages/utilities/zod';
import {InstructionGenerationType} from './instruction-type';
import type {InstructionGenerationInput} from './request';

export const NonCmsInstructionGenerationType =
  InstructionGenerationType.exclude(['cms-guidelines']);

export const CmsInstructionGenerationSubject = z.object({
  type: z.literal('cms-guidelines'),
  collectionId: objectIdStringZ4,
});

export const SiteInstructionGenerationSubject = z.object({
  type: NonCmsInstructionGenerationType,
  collectionId: z.never().optional(),
});

/** Stable identity of one generated instruction across generation tasks. */
export const InstructionGenerationSubject = z.discriminatedUnion('type', [
  CmsInstructionGenerationSubject,
  SiteInstructionGenerationSubject,
]);
export type InstructionGenerationSubject = z.infer<
  typeof InstructionGenerationSubject
>;

export function instructionGenerationSubject(
  input: InstructionGenerationInput
): InstructionGenerationSubject {
  return input.instructionType === 'cms-guidelines'
    ? {type: input.instructionType, collectionId: input.collectionId}
    : {type: input.instructionType};
}

export function instructionGenerationSubjectKey(
  subject: InstructionGenerationSubject
): string {
  return subject.type === 'cms-guidelines'
    ? `${subject.type}:${subject.collectionId}`
    : subject.type;
}
